import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Button, Icon } from '@material-ui/core';

import ActionsCourse from '../../../../store/ducks/course';

import useStyles from './styles';

const Error = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { course: courseId } = useSelector(state => state.course.current);

  const handleClickRetry = useCallback(() => {
    dispatch(ActionsCourse.requestCertificateHtml(courseId));
  }, [dispatch, courseId]);

  return (
    <Box className={classes.container}>
      <Box className="error-message-content">
        <Icon className="error-message-icon">warning</Icon>
        <Typography className="error-message-title" variant="h4">
          Certificado indisponível
        </Typography>
        <Typography className="error-message-description" variant="body1">
          Ocorreu um erro ao carregar o conteúdo do certificado.
        </Typography>
        <Button
          className="error-message-button"
          variant="contained"
          color="primary"
          onClick={handleClickRetry}
        >
          Tentar novamente
        </Button>
      </Box>
    </Box>
  );
};

export default Error;
